<template>
  <div class="grid grid-cols-1 gap-14 lg:grid-cols-2">
    <div>
      <div class="grid grid-cols-1 gap-14 lg:grid-cols-2">
        <div>
          <h3 class="text-10 text-black mb-6">
            {{ __('form.birthday_child') }}
          </h3>

          <div
            class="text-blue-900 mb-1 last:mb-0"
            v-if="order.data.birthday_child_name"
          >
            {{ order.data.birthday_child_name }}
          </div>

          <div
            class="text-blue-900 mb-1 last:mb-0"
            v-if="order.data.birthday_child_age"
          >
            {{ order.data.birthday_child_age }}
          </div>

          <div
            class="text-blue-900 mb-1 last:mb-0"
            v-if="order.data.birthday_child_gender"
          >
            {{ order.data.birthday_child_gender }}
          </div>
        </div>

        <div>
          <h3 class="text-10 mb-6">{{ __('form.responsible_adult') }}</h3>

          <div
            class="text-blue-900 mb-1 last:mb-0"
            v-if="order.data.responsible_adult_name"
          >
            {{ order.data.responsible_adult_name }}
          </div>

          <div
            class="text-blue-900 mb-1 last:mb-0"
            v-if="order.data.responsible_adult_phone"
          >
            {{ order.data.responsible_adult_phone }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3 class="text-10 mb-6">{{ __('form.comment') }}</h3>

      <div class="text-blue-900 mb-1 last:mb-0">
        {{ order.data.comment || '-' }}
      </div>
    </div>

    <div>
      <h3 class="text-10 mb-6">{{ __('title_catering') }}</h3>
      <div v-if="isUseYourOwnAmountService">{{ __('i_want_my_food') }}</div>

      <template v-else>
        <div v-if="!cateringServicesOverview.length">-</div>

        <div
          v-for="service in cateringServicesOverview"
          :key="service.id"
          class="text-blue-900 mb-1 last:mb-0"
        >
          <template v-if="service.item_name">
            {{ service.amount }}x {{ service.name }} - {{ service.item_name }}
          </template>

          <template v-else>
            {{ service.amount }}x {{ service.name }}
          </template>
        </div>
      </template>
    </div>

    <div>
      <h3 class="text-10 mb-6">{{ __('title_additional_services') }}</h3>

      <div v-if="!selectServices.length">-</div>

      <div
        v-for="service in selectServices"
        :key="service.id"
        class="text-blue-900 mb-1 last:mb-0"
      >
        {{ service.item_name }}
      </div>
    </div>
  </div>

  <div class="w-full mt-40">
    <Price class="mb-10" />
    <Alert v-if="message" class="mb-10">{{ message }}</Alert>

    <div class="flex justify-end flex-wrap -mx-6 -my-6">
      <div class="w-full p-6 md:w-1/2 lg:w-128">
        <Button
          variant="third"
          size="full"
          :disabled="loading"
          @click="prevStep"
        >
          {{ __('btn_back') }}
        </Button>
      </div>

      <div class="w-full p-6 md:w-1/2 lg:w-128">
        <Button
          variant="secondary"
          size="full"
          :loading="loading"
          @click="confirm"
        >
          {{ __('btn_confirm') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import {cateringServices} from "@/stores/Services";
import { computed, ref } from 'vue'
import { setPayView, setSelectServiceView } from '@/stores/View'
import { order, isUseYourOwnAmountService } from '@/stores/Order'

import Alert from '@/components/Alert'
import Button from '@/components/Button'
import Price from '@/components/Price'
import { banksInit } from '@/stores/banks'

export default {
  components: {
    Alert,
    Button,
    Price,
  },
  setup() {
    const loading = ref(false)
    const message = ref('')

    const confirm = async () => {
      loading.value = true
      await banksInit()
      setPayView()
    }

    const prevStep = () => {
      setSelectServiceView()
    }

    const cateringServiceIds = computed(() => {
      return [...cateringServices.value].map((service) => {
        return service.id
      })
    })

    const cateringServicesOverview = computed(() => {
      const collect = []
      order.value.paid_services.forEach((service) => {
        if (cateringServiceIds.value.includes(service.service_id)) {
          collect.push({
            id: service.id,
            name: service.name,
            amount: service.amount,
            item_name: service.item_name,
          })
        }
      })

      order.value.services.forEach((service) => {
        if (cateringServiceIds.value.includes(service.service_id)) {
          collect.push({
            id: service.id,
            name: service.name,
            amount: service.amount,
            item_name: service.item_name,
          })
        }
      })

      console.log(collect)
      return collect
    })

    const selectServices = computed(() => {
      const collect = []

      order.value.paid_services.forEach((service) => {
        if (!cateringServiceIds.value.includes(service.service_id)) {
          collect.push({
            id: service.id,
            name: service.name,
            item_name: service.item_name,
          })
        }
      })

      order.value.services.forEach((service) => {
        if (!cateringServiceIds.value.includes(service.service_id)) {
          collect.push({
            id: service.id,
            name: service.name,
            item_name: service.item_name,
          })
        }
      })

      return collect
    })

    return {
      loading,
      message,
      order,
      cateringServicesOverview,
      selectServices,
      confirm,
      prevStep,
      isUseYourOwnAmountService,
    }
  },
}
</script>
